import { render } from "./PerfAdventure.vue?vue&type=template&id=d70429a4"
import script from "./PerfAdventure.vue?vue&type=script&lang=js"
export * from "./PerfAdventure.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__